import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-700" }, "\n        Approve Amendment\n      ")
], -1);
const _hoisted_3 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_4 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "p-8" };
const _hoisted_6 = {
    key: 0,
    class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Approval Comments", -1);
const _hoisted_8 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_9 = {
    key: 1,
    class: "my-2 text-sm font-medium text-gray-700"
};
const _hoisted_10 = { key: 2 };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("p", { class: "my-2 text-sm font-medium text-gray-700" }, "Please select a HROps representitive for second line approval", -1);
const _hoisted_12 = {
    key: 1,
    class: "flex items-center"
};
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "mt-4 flex justify-end" };
const _hoisted_15 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_search = _resolveComponent("user-search");
    const _component_XIcon = _resolveComponent("XIcon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (['amend.notifyBudgetApprover', 'amend.notifyHROps'].includes(_ctx.amendsFormData.currentStageName))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_8, [
                                _withDirectives(_createElementVNode("textarea", {
                                    id: "about",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.approvalComment) = $event)),
                                    name: "about",
                                    rows: "3",
                                    class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                }, null, 512), [
                                    [_vModelText, _ctx.approvalComment]
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.amendsFormData.currentStageName === 'amend.notifyHROps')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "You will not be able to change this request once it has been approved. Are you sure you would like to approve this amendment request?"))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.amendsFormData.currentStageName === 'amend.notifyBudgetApprover')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            (!_ctx.user.userId)
                                ? (_openBlock(), _createBlock(_component_user_search, {
                                    key: 0,
                                    group: "HROPS",
                                    onUpdatedUser: _cache[1] || (_cache[1] = ($event) => (_ctx.handleUser($event)))
                                }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("input", {
                                        value: _ctx.user.email,
                                        disabled: "",
                                        type: "text",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed"
                                    }, null, 8, _hoisted_13),
                                    _createTextVNode(),
                                    _createElementVNode("button", {
                                        class: "h-5 w-5 ml-2",
                                        onClick: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.clearUser && _ctx.clearUser(...args)))
                                    }, [
                                        _createVNode(_component_XIcon, { class: "h-5 w-5 text-gray-400 hover:text-gray-800" })
                                    ])
                                ]))
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_14, [
                        (_ctx.amendsFormData.currentStageName === 'amend.notifyBudgetApprover')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: !_ctx.user.userId,
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleCompleteUser
                                        && _ctx.handleCompleteUser(...args)))
                            }, "\n                  Complete\n                ", 8, _hoisted_15))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        (_ctx.amendsFormData.currentStageName === 'amend.notifyHROps')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleCompleteUser
                                        && _ctx.handleCompleteUser(...args)))
                            }, "\n                  Complete\n                "))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ])
    ]));
}
